import { COPY_PLACEHOLDER_PATTERN } from "constants/i18n";
import { type CopyParams } from "types/i18n/CopyParams";

/**
 * Fills a copy slot's `{{name}}` placeholders from `params`. A passed `null`/`undefined` renders empty.
 *
 * @param params.template - One language's slot of a copy leaf.
 * @param params.params - A value per placeholder name.
 * @returns The slot with every placeholder replaced.
 * @throws When a placeholder's name is not passed at all — the call site passes the wrong names for this text.
 */
export function interpolateCopy({ template, params }: { template: string; params?: CopyParams }): string {
  return template.replace(COPY_PLACEHOLDER_PATTERN, (placeholder: string, name: string) => {
    if (!params || !Object.prototype.hasOwnProperty.call(params, name)) {
      throw new Error(
        `[copy] No value for ${placeholder} in "${template}"; passed: ${Object.keys(params ?? {}).join(", ")}`
      );
    }
    return String(params[name] ?? "");
  });
}
